<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-setting-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">

    <ul>
      <li :key="index" class="m-b-10" style="background-color: #F2F2F2"
          v-for="(item,index) in iteminfo.config.datalist">
        <div class="flex p-10" style="min-height: 90px">
          <div class="flex flex-1" style="flex-direction: column">
            <!--            <div class="w-full flex">-->
            <!--              <span>{{ item.title }}</span>-->

            <!--            </div>-->
            <div class="flex a-center" style="height: 100%">
              <Input v-model:value="item.name"></Input>
              <div class="flex-1 flex" style="justify-content: right;min-width: 120px">
                <RadioGroup  @on-change="showStatusChange(item)" v-model="item.isShow">
                  <Radio :label="1" class="">显示</Radio>
                  <Radio :label="2"  class="">隐藏</Radio>
                </RadioGroup>
              </div>
            </div>
          </div>
          <div class="flex-column a-center flex-s-0"
               style="width: 50px;justify-content: space-around;">
            <i :style="{color:getUpColor(index)}" @click.stop="onUpClick(index)"
               class="icon-up fs-18"
               style="cursor: pointer;"/>
            <i :style="{color:getDownColor(index,iteminfo.config.datalist.length)}"
               @click.stop="onDownClick(index)"
               class="icon-down fs-18"
               style="cursor: pointer;"/>
            <i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"
               style="cursor: pointer;color: #666666"/>
          </div>

        </div>
      </li>
    </ul>

    <div class="flex">
      <div class="color-33 fs-14 m-r-10 flex a-center">按钮名称:</div>
      <Input style="width: 200px" placeholder="按钮内容" v-model:value="iteminfo.config.btText"/>
    </div>

    <div class="flex m-t-10">
      <div class="color-33 fs-14  m-r-10 flex a-center">按钮背景:</div>
      <div class="border w-100 b-radius-3 flex a-center p-h-10" style="height: 32px">
        {{ iteminfo.config.btBgColor }}
      </div>
      <ColorPicker class="m-l-10 ld-color-pick" recommend
                   v-model="iteminfo.config.btBgColor"/>
    </div>

    <div class="flex m-t-10">
      <div class="color-33 fs-14  m-r-10 flex a-center">文字颜色:</div>
      <div class="border w-100 b-radius-3 flex a-center p-h-10" style="height: 32px">
        {{ iteminfo.config.btTextColor }}
      </div>
      <ColorPicker class="m-l-10 ld-color-pick" recommend
                   v-model="iteminfo.config.btTextColor"/>
    </div>


  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'

export default {
  name: 'PersonalInfoSettingWidget',
  components: {BaseSettingWidget},
  props: {
    iteminfo: Object
  },
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    onItemAddClick () {
      this.iteminfo.config.datalist.push({
        id: 0,
        coverImgUrl: '',
        title: ''
      })
    },
    onUpClick (index) {
      if (index > 0) {
        let item = this.iteminfo.config.datalist[index - 1]
        this.iteminfo.config.datalist.splice(index - 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDownClick (index) {
      if (index < (this.iteminfo.config.datalist.length - 1)) {
        let item = this.iteminfo.config.datalist[index + 1]
        this.iteminfo.config.datalist.splice(index + 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDelClick (index) {
      this.iteminfo.config.datalist.splice(index, 1)
    },
    getUpColor (index) {
      if (index === 0) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    getDownColor (index, length) {
      if (length === 0 || index === length - 1) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },

    /**
     * 至少选择一项
     */
    showStatusChange(item){
      let datalist = this.iteminfo.config.datalist
      let allHide = true
      for (let i = 0; i < datalist.length; i++) {
        if (datalist[i].isShow === 1) {
          allHide = false
          break
        }
      }
      if (allHide) {
        this.$Message.info('至少显示一项')
        setTimeout(()=>{
          item.isShow = 1
        },100)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
